module.exports = __webpack_public_path__ + "img/home.310c0ac4.svg";